import { round } from '../math';

export const ICE_CLASS_EU_ETS_DISCOUNT = 0.05;

export const getIceClassEuEtsTotals = (amount: number, isIceClass: boolean) => {
	const subTotal = round(amount);
	const discount = isIceClass ? round(subTotal * ICE_CLASS_EU_ETS_DISCOUNT) : 0;

	return {
		subTotal,
		discount,
		total: round(subTotal - discount),
	};
};
